import * as Types from '../../../../../../../graphql/generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type AddProductConfirmationDrawerUpdatesMutationVariables = Types.Exact<{
  registryItemId: Types.Scalars['ID'];
  payload: Types.UpdateRegistryItemPayload;
}>;

export type AddProductConfirmationDrawerUpdatesMutation = {
  __typename?: 'Mutation';
  updateRegistryItem: {
    __typename?: 'RegistryItem';
    id: string;
    isGroupGiftingEnabled?: boolean | null;
    isGetCashEquivalent?: boolean | null;
    note?: string | null;
    externallyOwned: boolean;
    canEditProductData: boolean;
    storeName?: string | null;
    fpIndex: number;
    stillNeeded: number;
    alreadyPurchased?: number | null;
    alreadyReserved?: number | null;
    totalRequested?: number | null;
    isHidden: boolean;
    mustHave: boolean;
    createAt: { __typename?: 'Date'; milliseconds: number; timestamp: any; timezone: string };
    productData: {
      __typename?: 'RegistryItemProductData';
      brand?: string | null;
      customType?: Types.CustomItemDataType | null;
      title: string;
      externalUrl?: string | null;
      checkoutUrl?: string | null;
      pdpUrl?: string | null;
      description?: string | null;
      isFullPrice: boolean;
      legacyType: Types.LegacyRegistryItemType;
      registryItem: { __typename?: 'RegistryItem'; id: string };
      price?: {
        __typename?: 'RegistryMonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; places: number } | null;
      } | null;
      fullPrice?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
    };
    donationFund?: {
      __typename?: 'DonationFund';
      id: string;
      fundType: Types.CustomItemDataType;
      suggestedQuantityStillNeeded?: number | null;
      donationsAreCapped: boolean;
      enforceSuggestedDonationAmount: boolean;
      hideFundingGoal: boolean;
      progressToGoalPercent?: number | null;
      fpIndex?: number | null;
      title: string;
      url?: string | null;
      description?: string | null;
      enableCashOrCheck?: boolean | null;
      enableAppPlatform: boolean;
      enableJoyCredit: boolean;
      mustHave: boolean;
      donations: Array<{
        __typename?: 'DonationFundDonation';
        id: string;
        name: string;
        email: string;
        note?: string | null;
        platformType?: Types.DonationFundPaymentMethodEnum | null;
        amount: {
          __typename?: 'MonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'Currency'; code: string; places: number } | null;
        };
        orderedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
      }>;
      goalMonetaryValue?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      suggestedDonationMonetaryValue?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      platform?: {
        __typename?: 'DonationFundPlatform';
        id?: string | null;
        type: Types.DonationFundPlatformTypeEnum;
        name: string;
        link?: string | null;
        username?: string | null;
      } | null;
      photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
      progressToGoal?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      amountTillGoalIsReached?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      currency: { __typename?: 'RegistryCurrency'; code: string; id: string; displayName: string };
    } | null;
  };
};

export const AddProductConfirmationDrawerUpdatesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddProductConfirmationDrawerUpdates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'registryItemId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateRegistryItemPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRegistryItem' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'registryItemId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryItem' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isGroupGiftingEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isGetCashEquivalent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externallyOwned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditProductData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'storeName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registryItem' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkoutUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdpUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'price' },
                  name: { kind: 'Name', value: 'priceAugmented' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fullPrice' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isFullPrice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fpIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stillNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alreadyPurchased' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alreadyReserved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalRequested' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'donationFund' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonationFund' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mustHave' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MonetaryValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'places' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DonationFund' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationFund' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'donations' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonationFundDonation' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fundType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'goalMonetaryValue' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suggestedDonationMonetaryValue' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedQuantityStillNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'donationsAreCapped' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enforceSuggestedDonationAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideFundingGoal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonationFundPlatform' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progressToGoal' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amountTillGoalIsReached' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'progressToGoalPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fpIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableCashOrCheck' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableAppPlatform' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableJoyCredit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mustHave' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DonationFundDonation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationFundDonation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amount' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'platformType' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DonationFundPlatform' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationFundPlatform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'link' } },
          { kind: 'Field', name: { kind: 'Name', value: 'username' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddProductConfirmationDrawerUpdatesMutationFn = Apollo.MutationFunction<
  AddProductConfirmationDrawerUpdatesMutation,
  AddProductConfirmationDrawerUpdatesMutationVariables
>;

/**
 * __useAddProductConfirmationDrawerUpdatesMutation__
 *
 * To run a mutation, you first call `useAddProductConfirmationDrawerUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductConfirmationDrawerUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductConfirmationDrawerUpdatesMutation, { data, loading, error }] = useAddProductConfirmationDrawerUpdatesMutation({
 *   variables: {
 *      registryItemId: // value for 'registryItemId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddProductConfirmationDrawerUpdatesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddProductConfirmationDrawerUpdatesMutation, AddProductConfirmationDrawerUpdatesMutationVariables>,
) {
  return ApolloReactHooks.useMutation<AddProductConfirmationDrawerUpdatesMutation, AddProductConfirmationDrawerUpdatesMutationVariables>(
    AddProductConfirmationDrawerUpdatesDocument,
    baseOptions,
  );
}
export type AddProductConfirmationDrawerUpdatesMutationHookResult = ReturnType<typeof useAddProductConfirmationDrawerUpdatesMutation>;
export type AddProductConfirmationDrawerUpdatesMutationResult = Apollo.MutationResult<AddProductConfirmationDrawerUpdatesMutation>;
export type AddProductConfirmationDrawerUpdatesMutationOptions = Apollo.BaseMutationOptions<
  AddProductConfirmationDrawerUpdatesMutation,
  AddProductConfirmationDrawerUpdatesMutationVariables
>;
